export default __webpack_public_path__ + "static/media/search.ba661d41.svg";